import { useEffect, useState } from 'react';
import {
  BILINGUE_RECOMMANDE,
  LANGUES_CHARTE,
  LANGUE_CHARTE_PAR_DEFAUT,
  LIBELLES_LANGUE_CHARTE,
  type BaremeApplicable,
  type LangueCharte,
  type RapportEdite,
} from '@rh/shared';
import { appel } from '../api';
import { Erreur } from './Etat';

/**
 * Édition du rapport de référence à faire signer : la trame complète du
 * dernier entretien, dans la langue choisie — la même que la charte par défaut.
 */
export function EditerRapport({
  candidatureId,
  onEdite,
}: {
  candidatureId: string;
  onEdite: (rapport: RapportEdite) => void;
}) {
  const [langue, setLangue] = useState<LangueCharte | ''>('');
  const [recommande, setRecommande] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => {
    appel<BaremeApplicable>(`/candidatures/${candidatureId}/bareme`)
      .then((bareme) => {
        const groupe = bareme.groupe;
        setLangue((actuelle) => actuelle || (groupe ? LANGUE_CHARTE_PAR_DEFAUT[groupe] : 'fr'));
        setRecommande(groupe !== null && BILINGUE_RECOMMANDE.includes(groupe));
      })
      .catch(() => setLangue((actuelle) => actuelle || 'fr'));
  }, [candidatureId]);

  async function editer(): Promise<void> {
    if (!langue) return;
    setErreur(null);
    setEnvoi(true);
    try {
      onEdite(
        await appel<RapportEdite>(`/candidatures/${candidatureId}/rapport`, {
          method: 'POST',
          body: JSON.stringify({ langue }),
        }),
      );
    } catch (e) {
      setErreur(e instanceof Error ? e.message : 'Édition du rapport impossible');
    } finally {
      setEnvoi(false);
    }
  }

  return (
    <div className="changer-statut">
      <select value={langue} aria-label="Langue du rapport" onChange={(e) => setLangue(e.target.value as LangueCharte)}>
        {LANGUES_CHARTE.map((l) => (
          <option key={l} value={l}>
            {LIBELLES_LANGUE_CHARTE[l]}
            {l === 'bilingue' && recommande ? ' — recommandé' : ''}
          </option>
        ))}
      </select>
      <button type="button" className="bouton-second" disabled={envoi || !langue} onClick={() => void editer()}>
        {envoi ? 'Génération…' : 'Éditer le rapport'}
      </button>
      {erreur && <Erreur message={erreur} />}
    </div>
  );
}
